export const roles = {
    ROLE_OPERATOR : "ROLE_OPERATOR",
    ROLE_SELLER : "ROLE_SELLER",
    ROLE_GIGARED: "ROLE_GIGARED",
    ROLE_USER: "ROLE_USER"
}